import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Tracking() {
  const navigate = useNavigate();
  const [currentStatus, setCurrentStatus] = useState(0);

  const statuses = [
    { id: 0, name: 'تم الاستلام', icon: 'ri-checkbox-circle-fill', time: '14:30' },
    { id: 1, name: 'قيد التجهيز', icon: 'ri-shopping-bag-fill', time: '14:35' },
    { id: 2, name: 'جاهز للتوصيل', icon: 'ri-box-3-fill', time: '14:50' },
    { id: 3, name: 'في الطريق', icon: 'ri-truck-fill', time: '15:00' },
    { id: 4, name: 'تم التسليم', icon: 'ri-home-smile-fill', time: '' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStatus((prev) => (prev < 3 ? prev + 1 : prev));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const progress = ((currentStatus + 1) / statuses.length) * 100;

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#0D47A1] to-[#1976D2] z-50">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/orders')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-2xl"></i>
          </button>
          <div className="flex-1">
            <h1 className="text-white text-lg font-bold">متابعة الطلب</h1>
            <p className="text-white/80 text-xs">رقم الطلب: #12345</p>
          </div>
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-customer-service-2-fill text-white text-xl"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20">
        {/* Map */}
        <div className="bg-white mb-3 h-72 relative">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.2!2d46.7!3d24.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzAwLjAiTiA0NsKwNDInMDAuMCJF!5e0!3m2!1sen!2ssa!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          ></iframe>
          
          {/* Delivery Info Overlay */}
          <div className="absolute bottom-4 left-4 right-4 bg-white rounded-2xl p-4 shadow-lg">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-[#0D47A1] to-[#1976D2] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-user-fill text-white text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-[#212121] font-bold text-sm">أحمد محمد</h3>
                <p className="text-gray-500 text-xs">مندوب التوصيل</p>
              </div>
              <button className="w-12 h-12 bg-[#4CAF50] rounded-full flex items-center justify-center">
                <i className="ri-phone-fill text-white text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="px-4">
          {/* Progress Bar */}
          <div className="bg-white rounded-2xl p-5 mb-3">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-[#212121] font-bold">حالة الطلب</h3>
              <span className="text-[#0D47A1] text-sm font-bold">{Math.round(progress)}%</span>
            </div>
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-4">
              <div
                className="h-full bg-gradient-to-r from-[#0D47A1] to-[#4CAF50] transition-all duration-500 rounded-full"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            {/* Status Timeline */}
            <div className="space-y-4">
              {statuses.map((status, index) => (
                <div key={status.id} className="flex items-start gap-3">
                  <div className="relative">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      index <= currentStatus
                        ? 'bg-gradient-to-br from-[#0D47A1] to-[#1976D2]'
                        : 'bg-gray-200'
                    }`}>
                      <i className={`${status.icon} text-xl ${
                        index <= currentStatus ? 'text-white' : 'text-gray-400'
                      }`}></i>
                    </div>
                    {index < statuses.length - 1 && (
                      <div className={`absolute top-10 right-5 w-0.5 h-8 ${
                        index < currentStatus ? 'bg-[#0D47A1]' : 'bg-gray-200'
                      }`}></div>
                    )}
                  </div>
                  <div className="flex-1 pt-2">
                    <h4 className={`font-bold text-sm mb-1 ${
                      index <= currentStatus ? 'text-[#212121]' : 'text-gray-400'
                    }`}>
                      {status.name}
                    </h4>
                    {status.time && (
                      <p className="text-gray-500 text-xs">{status.time}</p>
                    )}
                  </div>
                  {index === currentStatus && (
                    <div className="bg-[#4CAF50] text-white text-xs font-bold px-3 py-1 rounded-full">
                      الحالي
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Order Details */}
          <div className="bg-white rounded-2xl p-5 mb-3">
            <h3 className="text-[#212121] font-bold mb-4">تفاصيل الطلب</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">عدد المنتجات</span>
                <span className="text-[#212121] font-bold">3 منتجات</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">المبلغ الإجمالي</span>
                <span className="text-[#212121] font-bold">167 ر.س</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">طريقة الدفع</span>
                <span className="text-[#212121] font-bold">مدى</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">وقت التوصيل المتوقع</span>
                <span className="text-[#0D47A1] font-bold">15:30 - 15:45</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => navigate('/rating')}
              className="bg-white border-2 border-[#0D47A1] text-[#0D47A1] py-3 rounded-xl font-bold active:scale-95 transition-transform"
            >
              تقييم الطلب
            </button>
            <button className="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-3 rounded-xl font-bold active:scale-95 transition-transform">
              تواصل مع الدعم
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}